import React from 'react'
import { useNavigate, createSearchParams } from 'react-router-dom'
import { Box, Button, Typography } from '@mui/material'

const Mode3 = (props) => {

  
    const DisplayModeFrame = props.DisplayModeMasterFrame.DisplayModeSQL[0]
    const navigate = useNavigate('/hra')
    const handleStart = () => {
        fetch('../../WsWebServicePlatform/Participant/Setting/Set/' + props.auth + '/' + props.settings.SessionVariableValues["PERSON GUID"] + '/ASSMT%20PRODUCT%20GUID/' + props.settings.OrganizationSettingValues['ASSMT PRODUCT GUID'] + '/', {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: {
            }
        })
            .then(response => response.json())
            .then(response => {
                //console.log(response)
            })
            .then(fetch('../../WsWebServicePlatform/Participant/SessionVar/Delete/' + props.auth + '/RESPONSE%20GUID/', {
                method: "POST",
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: {
                }
            })
                .then(response => response.json())
                .then(response => {
                    //console.log(response)
                    navigate({ pathname: '/hra', search: createSearchParams({ vi: 'D58CC25B-BB6A-439D-B3D7-BA37AD1AB701' }).toString() })
                }))
    }
    return (
        <Box>
            <Box sx={{ width: { md: '66%', sm: '100%' } }}>
                <Typography variant="h4" paragraph>{DisplayModeFrame.SurveyDisplayMode3Frame.StartAssessmentHeadlineText}</Typography>
                <Button variant="contained"
                    onClick={() => handleStart()}><Typography variant="h6">{DisplayModeFrame.SurveyDisplayMode3Frame.StartAssessmentFrame.StartAssessmentButton}</Typography></Button>
            </Box>
            <Box sx={{ width: '33%' }}>

            </Box>
        </Box>
    )
}

export default Mode3